import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find.js";
import select2 from "select2";
var $ = require("jquery");
window.jQuery = $;
console.log(jQuery);
var parsley = require("./vendor/parsleyjs/parsley");
require("./vendor/parsleyjs/i18n/fr");
window.Parsley.setLocale("fr");
import { throttle, debounce } from "throttle-debounce";

// import { DateTime } from "./vendor/luxon";
import { DateTime } from "luxon";
import Trix from "trix";
require("magnific-popup");
var Dropzone = require("dropzone");
Dropzone.autoDiscover = false;
if (jQuery("#classified-creation-form").length) {
  var parsley_instance = jQuery("#classified-creation-form").parsley();
  window.Parsley.on("field:error", function () {
    // This global callback will be called for any field that fails validation.
    // console.log('Validation failed for: ', this.$element);
  });
}
var classifiedAddToCart = function classifiedAddToCart() {
  jQuery.post(i18n.ajaxurl, {
    action: "classified_add_to_cart"
  }, function (data) {
    if (data.status == "OK") {}
  });
};
var classifiedFormSubmit = function classifiedFormSubmit() {
  if (jQuery("#classified_content").length) {
    var classified_max_length = classifiedMaxLength();
    var classified_current_length = classifiedCurrentLength(editor);
    if (classified_max_length < classified_current_length) return;
  }
  jQuery.post(i18n.ajaxurl, {
    action: "classified_submit",
    form: jQuery(".classified-creation-form").serialize()
  }, function (data) {
    if (jQuery("#classified_preview_content").length) {
      jQuery("#classified_preview_content").html(data.preview);
    }
    if (jQuery(".classified_price").length) {
      jQuery(".classified_price span").html(data.price);
    }
    if (jQuery(".classified_publication").length) {
      if (data.publication.period) {
        jQuery(".classified_publication .period span").html(DateTime ? DateTime.fromISO(data.publication.period[1]).toLocaleString({
          year: "numeric",
          month: "numeric",
          day: "numeric"
        }) : data.publication.period[1]);
        jQuery(".classified_publication .period").show();
      }
      if (data.publication.publications) {
        jQuery(".classified_publication .publications div").html(data.publication.publications.join("<br />"));
        jQuery(".classified_publication .publications").show();
      }
    }
  });
};
var classifiedUpdatePreview = function classifiedUpdatePreview() {
  jQuery.post(i18n.ajaxurl, {
    action: "classified_preview"
  }, function (data) {
    if (jQuery("#classified_preview_content").length) {
      jQuery("#classified_preview_content").html(data.preview);
      gallerySlider();
    }
    if (jQuery(".classified_price").length) {
      jQuery(".classified_price span").html(data.price);
    }
  });
};
if (jQuery(".classified_format").length) {
  jQuery(".classified_format").on("change", classifiedFormSubmit);
  classifiedFormSubmit();
}
if (jQuery("#classified_duration").length) {
  jQuery("#classified_duration").on("change", classifiedFormSubmit);
  classifiedFormSubmit();
}
if (jQuery(".classified_option").length) {
  jQuery(".classified_option").on("change", classifiedFormSubmit);
  classifiedFormSubmit();
}
if (jQuery("#classified_preview_content").length) {
  classifiedUpdatePreview();
}
var classifiedMaxLength = function classifiedMaxLength() {
  var max_length = classified_max_length;
  return max_length;
};
var classifiedCurrentLength = function classifiedCurrentLength(editor) {
  var current_length = editor.getDocument().toString().length;
  var contact_length = jQuery("#classified_contact").val().length;
  var title_length = jQuery("#classified_title").val().length;
  var nb_images = jQuery(".dz-success").length;
  current_length = current_length + contact_length + title_length + nb_images * classified_image_length_cost;
  return current_length;
};
if (jQuery("#classified_content").length) {
  var processedDocumentText;
  var editor;
  var checkEditorMaxLength = function checkEditorMaxLength() {
    var classified_max_length = classifiedMaxLength();
    var classified_current_length = classifiedCurrentLength(editor);
    jQuery(".classified_content_length span").text(classified_max_length - classified_current_length);
    jQuery("[name='classified_content_length_input']").val(classified_max_length - classified_current_length);
    jQuery("[name='classified_post_content_length_input']").val(editor.getDocument().toString().trim().length);
    jQuery(".classified_content_length").toggleClass("classified_content_length_alert", classified_max_length < classified_current_length);
    debounce(500, classifiedFormSubmit)();
    var newDocumentText = editor.getDocument().toString();
    if (!processedDocumentText || processedDocumentText !== newDocumentText) {
      processedDocumentText = newDocumentText;
      var currentSelectedRange = editor.getSelectedRange();
      var editor_length = processedDocumentText.length;
      //deselect previous
      editor.setSelectedRange([0, editor_length]);
      editor.deactivateAttribute("strike");
      if (classified_max_length < classified_current_length) {
        editor.setSelectedRange([editor_length + classified_max_length - classified_current_length - 1, editor_length]);
        editor.activateAttribute("strike");
      }
      //restore state
      editor.setSelectedRange(currentSelectedRange);
    }
  };
  document.addEventListener("trix-initialize", function () {
    editor = document.querySelector("trix-editor").editor;
    checkEditorMaxLength();
  });

  // addEventListener("trix-change", debounce(150, classifiedFormSubmit));
  addEventListener("trix-change", debounce(500, checkEditorMaxLength));
  jQuery("#classified_contact, #classified_region, #classified_title").on("keyup", checkEditorMaxLength);
  jQuery("#classified_contact, #classified_region, #classified_title").on("change", debounce(150, classifiedFormSubmit));
  jQuery("#classified_contact, #classified_region, #classified_title, .trix-content").on("keyup", function () {
    parsley_instance.validate();
  });
}

// if ( jQuery('#classified-profil-recruiter').length) {
//     jQuery('#classified-profil-recruiter').on('click', function(){
//         alert("Veuillez vous connecter à votre compte Recruteur, pour créer une annonce.");
//         jQuery('#classified-profil-recruiter').prop('checked', false);
//     });
// }
// if (jQuery('.classified-profil').length) {
//     jQuery('.classified-profil').on('click', function() {
//         alert("Veuillez vous connecter pour créer une annonce.");
//         jQuery('.classified-profil').prop('checked', false);
//     });
// }

if (jQuery(".classified_medias").length) {
  var myDropzone = new Dropzone("div.classified_medias", {
    url: i18n.classified.urls.creation,
    uploadMultiple: true,
    acceptedFiles: "image/jpg,image/png,image/jpeg",
    maxFilesize: 2,
    maxFiles: jQuery(".classified_medias").data("max-files"),
    dictMaxFilesExceeded: "Nombre maximum de photo : {{maxFiles}}",
    paramName: "medias",
    addRemoveLinks: true,
    init: function init() {
      var thisDropzone = this;
      jQuery.get(i18n.classified.urls.creation + "?get_files", function (data) {
        jQuery.each(data, function (key, value) {
          if (!value) return;
          var mockFile = {
            name: value.name,
            size: value.size,
            attachment_id: value.attachment_id
          };
          thisDropzone.options.addedfile.call(thisDropzone, mockFile);
          thisDropzone.options.thumbnail.call(thisDropzone, mockFile, value.thumbnail);
          checkDropZoneMaxFiles();
          checkEditorMaxLength();
        });
      });
    }
  });
  myDropzone.on("success", function (file) {
    classifiedUpdatePreview();
    checkEditorMaxLength();
    checkDropZoneMaxFiles();
  });
  myDropzone.on("removedfile", function (file) {
    jQuery.get(i18n.classified.urls.creation + "?remove_file=" + file.attachment_id, function (data) {
      classifiedUpdatePreview();
      checkEditorMaxLength();
      checkDropZoneMaxFiles();
    });
  });
  var checkDropZoneMaxFiles = function checkDropZoneMaxFiles() {
    if (jQuery(".dz-preview").length >= myDropzone.options.maxFiles) {
      jQuery(".dz-hidden-input").attr("disabled", "disabled");
    } else {
      jQuery(".dz-hidden-input").removeAttr("disabled");
    }
  };
}
if (jQuery("#classified-options-extra_medias").length) {
  console.log(jQuery("#classified-options-extra_medias").prop("checked"));
  var checkExtraMediasOption = function checkExtraMediasOption() {
    jQuery(".option_extra_medias").toggle(jQuery("#classified-options-extra_medias").prop("checked"));
  };
  jQuery("#classified-options-extra_medias").on("change", checkExtraMediasOption);
  checkExtraMediasOption();
}
if (jQuery(".classified-category").length) {
  jQuery(".classified-category").on("change", function () {
    jQuery.post(i18n.ajaxurl, {
      action: "classified_submit",
      form: jQuery(".classified-creation-form").serialize()
    }, function (data) {
      if (jQuery(".classified_price").length) {
        jQuery(".classified_price span").html(data.price);
      }
    });
  });
}
if (jQuery(".classified_extra_medias").length) {
  var myDropzone = new Dropzone("div.classified_extra_medias", {
    url: i18n.classified.urls.creation,
    uploadMultiple: true,
    acceptedFiles: "image/jpg,image/png,image/jpeg",
    maxFilesize: 2,
    maxFiles: jQuery(".classified_extra_medias").data("max-files"),
    dictMaxFilesExceeded: "Nombre maximum de photo : {{maxFiles}}",
    paramName: "extra_medias",
    addRemoveLinks: true,
    init: function init() {
      var thisDropzone = this;
      jQuery.get(i18n.classified.urls.creation + "?get_extra_files", function (data) {
        jQuery.each(data, function (key, value) {
          if (!value) return;
          var mockFile = {
            name: value.name,
            size: value.size,
            attachment_id: value.attachment_id
          };
          thisDropzone.options.addedfile.call(thisDropzone, mockFile);
          thisDropzone.options.thumbnail.call(thisDropzone, mockFile, value.thumbnail);
          checkDropZoneMaxFiles();
          classifiedUpdatePreview();
        });
      });
    }
  });
  myDropzone.on("success", function (file) {
    checkDropZoneMaxFiles();
    classifiedUpdatePreview();
  });
  myDropzone.on("removedfile", function (file) {
    jQuery.get(i18n.classified.urls.creation + "?remove_extra_file=" + file.attachment_id, function (data) {
      checkDropZoneMaxFiles();
      classifiedUpdatePreview();
    });
  });
  var checkDropZoneMaxFiles = function checkDropZoneMaxFiles() {
    console.log(jQuery(".dz-preview").length);
    if (jQuery(".dz-preview").length >= myDropzone.options.maxFiles) {
      jQuery(".dz-hidden-input").attr("disabled", "disabled");
    } else {
      jQuery(".dz-hidden-input").removeAttr("disabled");
    }
  };
}
if (jQuery(".classified_logo").length) {
  var myDropzone = new Dropzone("div.classified_logo", {
    url: i18n.classified.urls.creation,
    maxFiles: 1,
    uploadMultiple: false,
    acceptedFiles: "image/jpg,image/png,image/jpeg",
    maxFilesize: 2,
    paramName: "logo",
    addRemoveLinks: true,
    init: function init() {
      var thisDropzone = this;
      jQuery.get(i18n.classified.urls.creation + "?get_logo", function (data) {
        jQuery.each(data, function (key, value) {
          if (!value) return;
          var mockFile = {
            name: value.name,
            size: value.size,
            attachment_id: value.attachment_id
          };
          thisDropzone.options.addedfile.call(thisDropzone, mockFile);
          thisDropzone.options.thumbnail.call(thisDropzone, mockFile, value.thumbnail);
          checkDropZoneMaxFiles();
        });
      });
    }
  });
  myDropzone.on("success", function (file) {
    checkDropZoneMaxFiles();
  });
  myDropzone.on("removedfile", function (file) {
    jQuery.get(i18n.classified.urls.creation + "?remove_logo=" + file.attachment_id, function (data) {
      // classifiedUpdatePreview();
      checkDropZoneMaxFiles();
    });
  });
  var checkDropZoneMaxFiles = function checkDropZoneMaxFiles() {
    console.log("checkDropZoneMaxFiles");
    console.log(jQuery(".dz-preview").length);
    if (jQuery(".dz-preview").length >= 1) {
      jQuery(".dz-hidden-input").attr("disabled", "disabled");
    } else {
      jQuery(".dz-hidden-input").removeAttr("disabled");
    }
  };
}
if (jQuery("#classified-author".length)) {
  jQuery("#classified-author").select2({
    minimumInputLength: 3,
    ajax: {
      url: i18n.ajaxurl,
      dataType: "json",
      data: function data(params) {
        return {
          q: params.term,
          action: "classified_authors"
        };
      },
      cache: true
    }
  });
  jQuery("#classified-author").on("select2:select", function (e) {
    jQuery.post(i18n.ajaxurl, {
      action: "classified_set_author",
      draft_id: jQuery("#classified-author").data("draft-id"),
      author_id: jQuery("#classified-author").val()
    }, function (data) {
      console.log(data);
    });
  });
}
var gallerySlider = function gallerySlider() {
  if (jQuery(".gallery-slider").length) {
    jQuery(".gallery-slider").each(function () {
      var $this = jQuery(this),
        $parent = $this.parent();
      if ($this.find(".swiper-slide").length > 1) {
        var _Swiper;
        var swiperPushSlider = new Swiper($this, (_Swiper = {
          speed: 800,
          loop: false,
          slidesPerView: 1,
          paginationClickable: true,
          navigation: {
            nextEl: $parent.find(".swiper-button-next"),
            prevEl: $parent.find(".swiper-button-prev")
          },
          spaceBetween: 0,
          a11y: true,
          prevSlideMessage: "Précédent",
          nextSlideMessage: "Suivant",
          paginationBulletMessage: "Accéder à l'image {{index}}"
        }, _defineProperty(_Swiper, "paginationClickable", true), _defineProperty(_Swiper, "pagination", {
          el: $parent.find(".swiper-pagination")
        }), _defineProperty(_Swiper, "onInit", function onInit() {
          $parent.find(".swiper-button-prev, .swiper-button-next, .swiper-pagination").show();
        }), _Swiper));
      }
    });
    jQuery(".swiper-wrapper").css({
      opacity: 1
    });
  }
};
if (jQuery(".classified-sample").length) {
  jQuery(".classified-sample").magnificPopup({
    type: "image",
    tLoading: "Chargement #%curr%...",
    mainClass: "mfp-img-mobile",
    image: {
      tError: "",
      titleSrc: function titleSrc(item) {
        if (item.el.attr("title")) {
          return item.el.attr("title");
        } else {
          return "";
        }
      },
      markup: '<div class="mfp-figure">' + '<div class="mfp-close"></div>' + '<div class="mfp-counter"></div>' + "<figure>" + '<div class="mfp-img"></div>' + "<figcaption>" + '<div class="mfp-bottom-bar">' + '<div class="mfp-title"></div>' + "</div>" + "</figcaption>" + "</figure>" + "</div>"
    }
  });
}